import { TipoSolucion } from './tipo-solucion.model';

export enum EstadoSolicitud {
  EN_CAPTURA = 'EN_CAPTURA',
  PREASIGNADA = 'PREASIGNADA',
  ASIGNADA = 'ASIGNADA',
  EN_ACTUALIZACION = 'EN_ACTUALIZACION',
  ENVIADA = 'ENVIADA',
  CANCELADA = 'CANCELADA',
  REVISADA = 'REVISADA',
  APROBADA = 'APROBADA',
  RECHAZADA = 'RECHAZADA',
  BAJA = 'BAJA',
  RECLASIFICADA = 'RECLASIFICADA',
  FORMALIZADA = 'FORMALIZADA',
  OPERACION_EN_PROCESO = 'OPERACION_EN_PROCESO',
  TERMINADO = 'TERMINADO',
  IMPROCEDENTE = 'IMPROCEDENTE',
  VALIDADA = 'VALIDADA',
  EN_CORRECCION = 'EN_CORRECCION',
  EN_FIRMA = 'EN_FIRMA',
  DICTAMINADA = 'DICTAMINADA',
  FINALIZADA = 'FINALIZADA',
  EN_EVALUACION = 'EN_EVALUACION',
  EVALUADA = 'EVALUADA',
  EN_ASIGNACION = 'EN_ASIGNACION',
  PREFORMALIZADA = 'PREFORMALIZADA',
  ACTUALIZADA = 'ACTUALIZADA',
  FIRMADA = 'FIRMADA',
  EN_VALORACION = 'EN_VALORACION',
}

const estadosPorTipoSolucion: Record<TipoSolucion, EstadoSolicitud[]> = {
  AYUDANTES: [],
  INGRESO_PERMANENCIA_PROMOCION: [],
  EMERITOS: [],
  BECAS_NACIONALES: [
    EstadoSolicitud.EN_CAPTURA,
    EstadoSolicitud.ENVIADA,
    EstadoSolicitud.REVISADA,
    EstadoSolicitud.PREASIGNADA,
    EstadoSolicitud.ASIGNADA,
    EstadoSolicitud.FORMALIZADA,
    EstadoSolicitud.FINALIZADA,
  ],
  BECAS_EXTRANJERAS: [],
  POSGRADO_NACIONAL: [],
  POSDOCTORADO: [],
  CUENTAS_BANCARIAS: [],
  ACREDITACIONES: [],
  ACREDITACIONES_SIN_INST: [],
  INSTITUCIONES: [],
  REGISTRO_MATRICULA_SNP: [],
  MOVIMIENTOS_SITUACION: [],
  ACREDITACIONES_PROGRAMAS: [],
  REGISTRO_MATRICULA_LIC: [],
  APOYOS_COMPLEMENTARIOS_BN: [],
  APOYOS_COMPLEMENTARIOS_EXT: [],
  ACREDITACION_MASIVA: [],
  EXCEPCIONES_SNII: [],
  EXCEPCIONES_EMERITOS_65: [],
  EXPEDIENTE_PERSONA: [],
  CUENTAS_BANCARIAS_SNII_INV: [],
  CUENTAS_BANCARIAS_SNII_AYU: [],
  FORMATO_1_POSGRADO_NACIONAL: [],
  DIASPORA: [],
  ACTIVIDAD_RETRIBUCION_SOCIAL: [],
};

export default function obtenerEstadosPorTipoSolucion(tipo: TipoSolucion.BECAS_NACIONALES): EstadoSolicitud[] {
  return estadosPorTipoSolucion[tipo];
}
